// extracted by mini-css-extract-plugin
export default {"container":"container-BAeY6n7t","title":"title-Ofe7KDYO"};